import React from 'react';
import { generatePath, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Table } from 'react-bootstrap';

import { getRouteByName } from 'app/routes';
import { formatDate } from 'shared-pages/utils/helpers';
import { CollectionOrdersStatusesBadge } from './collection-orders-statuses-badge';
import { CollectionOrderStates } from 'shared-pages/common/constants';

export type CollectionOrderStatusRow = {
  id: number;
  statusId: number;
  code: string;
  orderedDate: string;
  collectionpoint?: { name?: string; addressArea?: string; addressCity?: string };
  collector?: { name?: string };
  collectionOrderState?: { name?: string };
  plannedCollectionDate?: string;
};

type Props = {
  rows: CollectionOrderStatusRow[];
};

export const CollectionOrdersStatusesTable = ({ rows }: Props) => {
  const { t } = useTranslation();

  return (
    <Table responsive hover className="status-orders-table mb-0 align-middle">
      <thead>
        <tr>
          <th>{t('Κωδικός Αίτησης')}</th>
          <th>{t('Ημερομηνία Αίτησης')}</th>
          <th>{t('Σημείο Συλλογής')}</th>
          <th>{t('Κατάσταση Αίτησης')}</th>
          <th>{t('Συλλέκτης')}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <td>
              <Link
                to={generatePath(getRouteByName('Order'), { id: row.id })}
                className="status-order-link"
              >
                {row.code}
              </Link>
            </td>
            <td>{row.orderedDate ? formatDate(row.orderedDate) : '—'}</td>
            <td>
              {row.collectionpoint?.name ? (
                <>
                  <div>{row.collectionpoint.name}</div>
                  <div className="text-muted small">
                    {[row.collectionpoint.addressArea, row.collectionpoint.addressCity]
                      .filter(Boolean)
                      .join(', ')}
                  </div>
                </>
              ) : (
                '—'
              )}
            </td>
            <td>
              <CollectionOrdersStatusesBadge
                value={row.statusId}
                name={row.collectionOrderState?.name}
              />
            </td>
            {/* Συλλέκτης */}
            <td>
              {row.collector?.name ?? '—'}
              {row.statusId === CollectionOrderStates.ScheduledCollectorCollection && (
                <div className="text-left">
                  <span className="text-muted">Προγραμματισμένη Συλλογή:</span>
                  <br />
                  {formatDate(row.plannedCollectionDate)}
                </div>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
